export enum LoginWithGoogleReturnPath {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  PRICING = 'PRICING',
}
